import { render, staticRenderFns } from "./DeleteDeviceModel.vue?vue&type=template&id=4128c624"
import script from "./DeleteDeviceModel.vue?vue&type=script&lang=ts"
export * from "./DeleteDeviceModel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports